import React from 'react';
import { Icon } from '@/shared/icons'
interface NotificationBadgeProps {
  count: number;
  onClick?: () => void;
  isActive?: boolean;
  /**
   * 'sm' (default) = util-row do rodapé da sidebar (32px, ícone 18px).
   * 'md' = appbar mobile (38px/raio 11px, ícone 22px, badge top:5/right:5 — mockup `.m-ibtn`).
   */
  size?: 'sm' | 'md';
}

/**
 * Notification badge icon with unread count
 * Used in the sidebar util-row (footer). Forwards a ref to the trigger button
 * so the parent can measure it (getBoundingClientRect) to position the portaled panel.
 */
export const NotificationBadge = React.forwardRef<HTMLButtonElement, NotificationBadgeProps>(({
  count,
  onClick,
  isActive = false,
  size = 'sm'
}, ref) => {
  const isMd = size === 'md';
  // No rail/toolbar da sidebar (sm) o hover segue o token da sidebar; no appbar (md) mantém o do card.
  const hoverBg = isMd ? 'var(--theme-button-ghost-hover)' : 'rgba(148,163,184,0.14)';
  return (
    <button
      ref={ref}
      onClick={onClick}
      className={
        isMd
          ? 'relative w-[38px] h-[38px] flex items-center justify-center rounded-[11px] flex-none transition-colors'
          : 'relative w-[32px] h-[32px] flex items-center justify-center rounded-lg transition-colors'
      }
      style={{
        backgroundColor: isActive ? hoverBg : 'transparent',
        // Uniformizado com os demais ícones do contexto (util-row=sidebar / appbar=card)
        color: isMd ? 'var(--theme-card-text)' : 'var(--theme-sidebar-text)'
      }}
      onMouseEnter={(e) => {
        if (!isActive) {
          e.currentTarget.style.backgroundColor = hoverBg;
        }
      }}
      onMouseLeave={(e) => {
        if (!isActive) {
          e.currentTarget.style.backgroundColor = 'transparent';
        }
      }}
    >
      <Icon name="bell" className={isMd ? 'w-[22px] h-[22px]' : 'w-[18px] h-[18px]'} />

      {/* `.util .badge` do mockup: 16px, 9px bold, top/right -2 (sm) / 5/5 (md appbar) */}
      {count > 0 && (
        <span
          className="absolute flex items-center justify-center font-bold text-white rounded-full"
          style={{
            top: isMd ? 5 : -2, right: isMd ? 5 : -2, minWidth: 16, height: 16,
            padding: '0 4px', fontSize: 9, lineHeight: 1,
            backgroundColor: '#ef4444',
          }}
        >
          {count > 99 ? '99+' : count}
        </span>
      )}
    </button>
  );
});

NotificationBadge.displayName = 'NotificationBadge';
